// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23db0b27%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter-select-filters > .dropdown {
  display: inline;
  /* margin-right: 1em; */
}

.filter-select-filters .btn-filter-secondary {
  text-align: center;
}

.filter-select-filters .btn-filter-secondary {
  max-width: 9.7em;
  width: 9.7em;
}

.filter-select-filters .dropdown:last-of-type .btn-filter-secondary {
  max-width: 9.7em;
  width: 9.7em;
}

.btn-filter-secondary ~ * .form-check-input[type="radio"] {
  border-radius: 50%;
}

.btn-filter-secondary ~ * .form-check-input[type="radio"] ~ label {
  font-weight: 600;
  padding-left: 0.5em;
  vertical-align: middle;
}

.btn-filter-secondary ~ * .filter-form .form-check-input[type="radio"]:focus {
  border-color: #db0b27;
}

.btn-filter-secondary ~ * .filter-form .form-check-input[type="radio"]:focus {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.btn-filter-secondary ~ * .filter-form .form-check-input[type="radio"]:checked {
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.filter-form input[type="radio"]:checked:after,
.form-check-input:checked[type="radio"] {
  content: none !important;
}

/* .dropdown-item.active,
.dropdown-item:active {
  color: #2b363b;
} */

.dropdown-item.active
  .btn-filter-secondary
  ~ *
  .form-check-input[type="radio"]:checked,
.dropdown-item:active
  .btn-filter-secondary
  ~ *
  .form-check-input[type="radio"]:checked {
  background: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.filter-select-filters input[type="radio"] {
  width: 1em;
  height: 1em;
}

.filter-select-filters .form-check-input:checked[type="radio"] {
  font-size: inherit;
}

.btn-filter-secondary ~ .dropdown-menu:last-of-type {
  max-width: 9.7em;
  min-width: 100%;
  width: 9.7em;
}

.dropdown {
  display: inline;
  margin-right: 0.48em;
}

.filter-select-filters .btn-filter-secondary {
  text-align: center;
}

.filter-select-filters .btn-filter-secondary.show {
  border-color: transparent;
  background-color: transparent;
}

.filter-select-filters .btn-filter-secondary:first-child:active {
  border-color: transparent;
  background-color: transparent;
}

.btn-filter-secondary {
  background-color: #fff;
  border-color: transparent;
  border-radius: 0.7em;
  box-shadow: 0px 7px 10px -5px rgb(0 0 0 / 60%);
  color: #2b363b;
  font-weight: 600;
  padding-left: 1.53em;
  padding-top: 0.768em;
  padding-bottom: 0.768em;
}

.btn-filter-secondary:hover,
.btn-filter-secondary:focus,
.btn-filter-secondary:active,
.btn-filter-secondary:active:focus {
  background-color: #fff;
  border-color: transparent;
  box-shadow: 0px 7px 10px -5px rgb(0 0 0 / 60%);
  color: #2b363b;
}

.btn-filter-secondary::after {
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
  color: #2b363b;
  content: "" !important;
  font-size: inherit;
  font-weight: 600;
  margin-left: 1.02em;
}

.filter-secondary > .btn-primary.dropdown-toggle {
  background-color: #fff;
  border-color: transparent;
  color: #2b363b;
}

.filter-secondary > .btn-primary.dropdown-toggle:focus {
  box-shadow: 0px 7px 10px -5px rgb(0 0 0 / 60%);
}

.btn-filter-secondary ~ * .form-check-input[type="radio"] {
  border-radius: 50%;
}

.btn-filter-secondary ~ * .form-check-input[type="radio"] ~ label,
.btn-filter-secondary ~ * .form-check-input[type="checkbox"] ~ label {
  font-weight: 600;
  padding-left: 0.51em;
  vertical-align: middle;
}

.btn-filter-secondary ~ * .form-check-input[type="checkbox"] ~ label {
  color: #c4c4c4;
}

.btn-filter-secondary ~ * .form-check-input[type="checkbox"]:checked ~ label {
  color: #2b363b;
}

.btn-filter-secondary ~ * .filter-form .form-check-input[type="radio"]:focus {
  border-color: #db0b27;
}

.btn-filter-secondary ~ * .filter-form .form-check-input[type="radio"]:focus {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.btn-filter-secondary ~ * .filter-form .form-check-input[type="radio"]:checked {
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.filter-form input[type="radio"]:checked:after,
.form-check-input:checked[type="radio"] {
  content: none !important;
}

/* .dropdown-item.active,
.dropdown-item:active {
  color: #2b363b;
} */

.dropdown-item.active
  .btn-filter-secondary
  ~ *
  .form-check-input[type="radio"]:checked,
.dropdown-item:active
  .btn-filter-secondary
  ~ *
  .form-check-input[type="radio"]:checked {
  background: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.filter-select-filters input[type="radio"] {
  width: 1em;
  height: 1em;
}

.filter-select-filters .form-check-input:checked[type="radio"] {
  font-size: inherit;
}

.btn-filter-secondary ~ .dropdown-menu {
  border-radius: 0 0 0.7em 0.7em;
  border: none;
  box-shadow: 0px 7px 10px -5px rgb(0 0 0 / 0.6);
  max-height: 13em;
  overflow-y: scroll;
}

.btn-filter-secondary ~ .dropdown-menu:last-of-type {
  background: #fff;
  transform: translate3d(0, 20.2px, 0px) !important;
}

/* BREAKPOINT TABLETS*/
@media (min-width: 768px) {
}

/* BREAKPOINT ESCRITORIO */
@media (min-width: 992px) {
  .filter-select-filters {
    text-align: right;
  }

  .filter-select-filters .btn-filter-secondary {
    max-width: 50%;
    width: 50%;
  }

  .filter-select-filters.repostajes .btn-filter-secondary {
    max-width: 20%;
    width: 20%;
  }

  .filter-select-filters.repostajes #dropdown-basic-button-anios {
    max-width: 15%;
    width: 15%;
  }

  .filter-select-filters .dropdown:last-of-type .btn-filter-secondary {
    max-width: 30%;
    width: 30%;
  }

  .btn-filter-secondary ~ .dropdown-menu::-webkit-scrollbar {
    width: 12px; /* width of the entire scrollbar */
  }

  .btn-filter-secondary ~ .dropdown-menu::-webkit-scrollbar-thumb {
    background-color: #c4c4c4; /* color of the scroll thumb */
    border-radius: 20px; /* roundness of the scroll thumb */
    border: 3px solid #fff; /* creates padding around scroll thumb */
  }

  .filter-select-filters {
    text-align: right;
  }

  .filter-select-filters .filter-matricula .btn-filter-secondary {
    max-width: 20%;
    width: 20%;
  }

  .filter-select-filters .filter-vehiculo .btn-filter-secondary {
    max-width: 22%;
    width: 22%;
  }

  .filter-select-filters .filter-month .btn-filter-secondary {
    max-width: 22%;
    width: 22%;
  }

  .filter-select-filters .filter-year .btn-filter-secondary {
    max-width: 20%;
    width: 20%;
  }

  .btn-filter-secondary ~ .dropdown-menu {
    border-radius: 0 0 0.7em 0.7em;
    max-height: 180px;
    max-width: 40%;
    overflow-x: hidden;
    scrollbar-width: thin; /* "auto" or "thin" */
    scrollbar-color: #c4c4c4 transparent;
    width: 40%;
  }

  .btn-filter-secondary ~ .dropdown-menu:last-of-type {
    background: #fff;
    max-width: 30% !important;
    width: 30% !important;
    transform: translate3d(0, 26.2px, 0px) !important;
    min-width: 100%;
    overflow: auto;
  }

  .btn-filter-secondary ~ .dropdown-menu::-webkit-scrollbar {
    width: 12px; /* width of the entire scrollbar */
  }

  .btn-filter-secondary ~ .dropdown-menu::-webkit-scrollbar-thumb {
    background-color: #c4c4c4; /* color of the scroll thumb */
    border-radius: 20px; /* roundness of the scroll thumb */
    border: 3px solid #fff; /* creates padding around scroll thumb */
  }

  .btn-filter-secondary ~ .dropdown-menu .save-filters {
    box-shadow: 0px -2px 9px -5px rgb(0 0 0 / 60%);
    padding-left: 0;
    padding-right: 0;
  }

  a.save-filters.dropdown-item {
    background-color: transparent;
  }

  .btn-filter-secondary ~ .dropdown-menu .save-filters button {
    color: #db0b27;
    font-size: 0.7rem;
    font-weight: 600;
    margin-bottom: -0.5rem !important;
    text-transform: uppercase;
    width: inherit;
    margin: 0 auto;
  }

  .btn-filter-secondary ~ .dropdown-menu .save-filters button:hover {
    background-color: #fdf4f4;
  }

  .filter-form-checkbox {
    padding: 0.25em 2.5em;
  }

  .filter-dropdown,
  .filter-dropdown .form-check-input,
  .filter-dropdown .form-check-label {
    cursor: pointer;
  }

  .filter-form-checkbox .form-check-input[type="checkbox"],
  .filter-dropdown .form-check-input[type="checkbox"] {
    font-size: 17px;
    line-height: 17px;
  }

  .dropdown-autoclose-inside:focus-visible {
    outline: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/filtros/selects.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yDAA0J;AAC5J;;AAEA;EACE,sBAAsB;EACtB,yDAA0J;AAC5J;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;;GAGG;;AAEH;;;;;;;;EAQE,gBAAgB;EAChB,yDAA0J;AAC5J;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;EACpB,8CAA8C;EAC9C,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;;;;EAIE,sBAAsB;EACtB,yBAAyB;EACzB,8CAA8C;EAC9C,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,gBAAgB;EAChB,oCAAoC;EACpC,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yDAA0J;AAC5J;;AAEA;EACE,sBAAsB;EACtB,yDAA0J;AAC5J;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;;GAGG;;AAEH;;;;;;;;EAQE,gBAAgB;EAChB,yDAA0J;AAC5J;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,8CAA8C;EAC9C,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA,sBAAsB;AACtB;AACA;;AAEA,0BAA0B;AAC1B;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,WAAW,EAAE,kCAAkC;EACjD;;EAEA;IACE,yBAAyB,EAAE,8BAA8B;IACzD,mBAAmB,EAAE,kCAAkC;IACvD,sBAAsB,EAAE,wCAAwC;EAClE;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,8BAA8B;IAC9B,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,qBAAqB,EAAE,qBAAqB;IAC5C,oCAAoC;IACpC,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,iDAAiD;IACjD,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,WAAW,EAAE,kCAAkC;EACjD;;EAEA;IACE,yBAAyB,EAAE,8BAA8B;IACzD,mBAAmB,EAAE,kCAAkC;IACvD,sBAAsB,EAAE,wCAAwC;EAClE;;EAEA;IACE,8CAA8C;IAC9C,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,iCAAiC;IACjC,yBAAyB;IACzB,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;;IAEE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".filter-select-filters > .dropdown {\n  display: inline;\n  /* margin-right: 1em; */\n}\n\n.filter-select-filters .btn-filter-secondary {\n  text-align: center;\n}\n\n.filter-select-filters .btn-filter-secondary {\n  max-width: 9.7em;\n  width: 9.7em;\n}\n\n.filter-select-filters .dropdown:last-of-type .btn-filter-secondary {\n  max-width: 9.7em;\n  width: 9.7em;\n}\n\n.btn-filter-secondary ~ * .form-check-input[type=\"radio\"] {\n  border-radius: 50%;\n}\n\n.btn-filter-secondary ~ * .form-check-input[type=\"radio\"] ~ label {\n  font-weight: 600;\n  padding-left: 0.5em;\n  vertical-align: middle;\n}\n\n.btn-filter-secondary ~ * .filter-form .form-check-input[type=\"radio\"]:focus {\n  border-color: #db0b27;\n}\n\n.btn-filter-secondary ~ * .filter-form .form-check-input[type=\"radio\"]:focus {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23db0b27'/%3e%3c/svg%3e\");\n}\n\n.btn-filter-secondary ~ * .filter-form .form-check-input[type=\"radio\"]:checked {\n  background-color: #fff;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23db0b27'/%3e%3c/svg%3e\");\n}\n\n.filter-form input[type=\"radio\"]:checked:after,\n.form-check-input:checked[type=\"radio\"] {\n  content: none !important;\n}\n\n/* .dropdown-item.active,\n.dropdown-item:active {\n  color: #2b363b;\n} */\n\n.dropdown-item.active\n  .btn-filter-secondary\n  ~ *\n  .form-check-input[type=\"radio\"]:checked,\n.dropdown-item:active\n  .btn-filter-secondary\n  ~ *\n  .form-check-input[type=\"radio\"]:checked {\n  background: #fff;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23db0b27'/%3e%3c/svg%3e\");\n}\n\n.filter-select-filters input[type=\"radio\"] {\n  width: 1em;\n  height: 1em;\n}\n\n.filter-select-filters .form-check-input:checked[type=\"radio\"] {\n  font-size: inherit;\n}\n\n.btn-filter-secondary ~ .dropdown-menu:last-of-type {\n  max-width: 9.7em;\n  min-width: 100%;\n  width: 9.7em;\n}\n\n.dropdown {\n  display: inline;\n  margin-right: 0.48em;\n}\n\n.filter-select-filters .btn-filter-secondary {\n  text-align: center;\n}\n\n.filter-select-filters .btn-filter-secondary.show {\n  border-color: transparent;\n  background-color: transparent;\n}\n\n.filter-select-filters .btn-filter-secondary:first-child:active {\n  border-color: transparent;\n  background-color: transparent;\n}\n\n.btn-filter-secondary {\n  background-color: #fff;\n  border-color: transparent;\n  border-radius: 0.7em;\n  box-shadow: 0px 7px 10px -5px rgb(0 0 0 / 60%);\n  color: #2b363b;\n  font-weight: 600;\n  padding-left: 1.53em;\n  padding-top: 0.768em;\n  padding-bottom: 0.768em;\n}\n\n.btn-filter-secondary:hover,\n.btn-filter-secondary:focus,\n.btn-filter-secondary:active,\n.btn-filter-secondary:active:focus {\n  background-color: #fff;\n  border-color: transparent;\n  box-shadow: 0px 7px 10px -5px rgb(0 0 0 / 60%);\n  color: #2b363b;\n}\n\n.btn-filter-secondary::after {\n  border-top: 0.3em solid;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0;\n  border-left: 0.3em solid transparent;\n  color: #2b363b;\n  content: \"\" !important;\n  font-size: inherit;\n  font-weight: 600;\n  margin-left: 1.02em;\n}\n\n.filter-secondary > .btn-primary.dropdown-toggle {\n  background-color: #fff;\n  border-color: transparent;\n  color: #2b363b;\n}\n\n.filter-secondary > .btn-primary.dropdown-toggle:focus {\n  box-shadow: 0px 7px 10px -5px rgb(0 0 0 / 60%);\n}\n\n.btn-filter-secondary ~ * .form-check-input[type=\"radio\"] {\n  border-radius: 50%;\n}\n\n.btn-filter-secondary ~ * .form-check-input[type=\"radio\"] ~ label,\n.btn-filter-secondary ~ * .form-check-input[type=\"checkbox\"] ~ label {\n  font-weight: 600;\n  padding-left: 0.51em;\n  vertical-align: middle;\n}\n\n.btn-filter-secondary ~ * .form-check-input[type=\"checkbox\"] ~ label {\n  color: #c4c4c4;\n}\n\n.btn-filter-secondary ~ * .form-check-input[type=\"checkbox\"]:checked ~ label {\n  color: #2b363b;\n}\n\n.btn-filter-secondary ~ * .filter-form .form-check-input[type=\"radio\"]:focus {\n  border-color: #db0b27;\n}\n\n.btn-filter-secondary ~ * .filter-form .form-check-input[type=\"radio\"]:focus {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23db0b27'/%3e%3c/svg%3e\");\n}\n\n.btn-filter-secondary ~ * .filter-form .form-check-input[type=\"radio\"]:checked {\n  background-color: #fff;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23db0b27'/%3e%3c/svg%3e\");\n}\n\n.filter-form input[type=\"radio\"]:checked:after,\n.form-check-input:checked[type=\"radio\"] {\n  content: none !important;\n}\n\n/* .dropdown-item.active,\n.dropdown-item:active {\n  color: #2b363b;\n} */\n\n.dropdown-item.active\n  .btn-filter-secondary\n  ~ *\n  .form-check-input[type=\"radio\"]:checked,\n.dropdown-item:active\n  .btn-filter-secondary\n  ~ *\n  .form-check-input[type=\"radio\"]:checked {\n  background: #fff;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23db0b27'/%3e%3c/svg%3e\");\n}\n\n.filter-select-filters input[type=\"radio\"] {\n  width: 1em;\n  height: 1em;\n}\n\n.filter-select-filters .form-check-input:checked[type=\"radio\"] {\n  font-size: inherit;\n}\n\n.btn-filter-secondary ~ .dropdown-menu {\n  border-radius: 0 0 0.7em 0.7em;\n  border: none;\n  box-shadow: 0px 7px 10px -5px rgb(0 0 0 / 0.6);\n  max-height: 13em;\n  overflow-y: scroll;\n}\n\n.btn-filter-secondary ~ .dropdown-menu:last-of-type {\n  background: #fff;\n  transform: translate3d(0, 20.2px, 0px) !important;\n}\n\n/* BREAKPOINT TABLETS*/\n@media (min-width: 768px) {\n}\n\n/* BREAKPOINT ESCRITORIO */\n@media (min-width: 992px) {\n  .filter-select-filters {\n    text-align: right;\n  }\n\n  .filter-select-filters .btn-filter-secondary {\n    max-width: 50%;\n    width: 50%;\n  }\n\n  .filter-select-filters.repostajes .btn-filter-secondary {\n    max-width: 20%;\n    width: 20%;\n  }\n\n  .filter-select-filters.repostajes #dropdown-basic-button-anios {\n    max-width: 15%;\n    width: 15%;\n  }\n\n  .filter-select-filters .dropdown:last-of-type .btn-filter-secondary {\n    max-width: 30%;\n    width: 30%;\n  }\n\n  .btn-filter-secondary ~ .dropdown-menu::-webkit-scrollbar {\n    width: 12px; /* width of the entire scrollbar */\n  }\n\n  .btn-filter-secondary ~ .dropdown-menu::-webkit-scrollbar-thumb {\n    background-color: #c4c4c4; /* color of the scroll thumb */\n    border-radius: 20px; /* roundness of the scroll thumb */\n    border: 3px solid #fff; /* creates padding around scroll thumb */\n  }\n\n  .filter-select-filters {\n    text-align: right;\n  }\n\n  .filter-select-filters .filter-matricula .btn-filter-secondary {\n    max-width: 20%;\n    width: 20%;\n  }\n\n  .filter-select-filters .filter-vehiculo .btn-filter-secondary {\n    max-width: 22%;\n    width: 22%;\n  }\n\n  .filter-select-filters .filter-month .btn-filter-secondary {\n    max-width: 22%;\n    width: 22%;\n  }\n\n  .filter-select-filters .filter-year .btn-filter-secondary {\n    max-width: 20%;\n    width: 20%;\n  }\n\n  .btn-filter-secondary ~ .dropdown-menu {\n    border-radius: 0 0 0.7em 0.7em;\n    max-height: 180px;\n    max-width: 40%;\n    overflow-x: hidden;\n    scrollbar-width: thin; /* \"auto\" or \"thin\" */\n    scrollbar-color: #c4c4c4 transparent;\n    width: 40%;\n  }\n\n  .btn-filter-secondary ~ .dropdown-menu:last-of-type {\n    background: #fff;\n    max-width: 30% !important;\n    width: 30% !important;\n    transform: translate3d(0, 26.2px, 0px) !important;\n    min-width: 100%;\n    overflow: auto;\n  }\n\n  .btn-filter-secondary ~ .dropdown-menu::-webkit-scrollbar {\n    width: 12px; /* width of the entire scrollbar */\n  }\n\n  .btn-filter-secondary ~ .dropdown-menu::-webkit-scrollbar-thumb {\n    background-color: #c4c4c4; /* color of the scroll thumb */\n    border-radius: 20px; /* roundness of the scroll thumb */\n    border: 3px solid #fff; /* creates padding around scroll thumb */\n  }\n\n  .btn-filter-secondary ~ .dropdown-menu .save-filters {\n    box-shadow: 0px -2px 9px -5px rgb(0 0 0 / 60%);\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  a.save-filters.dropdown-item {\n    background-color: transparent;\n  }\n\n  .btn-filter-secondary ~ .dropdown-menu .save-filters button {\n    color: #db0b27;\n    font-size: 0.7rem;\n    font-weight: 600;\n    margin-bottom: -0.5rem !important;\n    text-transform: uppercase;\n    width: inherit;\n    margin: 0 auto;\n  }\n\n  .btn-filter-secondary ~ .dropdown-menu .save-filters button:hover {\n    background-color: #fdf4f4;\n  }\n\n  .filter-form-checkbox {\n    padding: 0.25em 2.5em;\n  }\n\n  .filter-dropdown,\n  .filter-dropdown .form-check-input,\n  .filter-dropdown .form-check-label {\n    cursor: pointer;\n  }\n\n  .filter-form-checkbox .form-check-input[type=\"checkbox\"],\n  .filter-dropdown .form-check-input[type=\"checkbox\"] {\n    font-size: 17px;\n    line-height: 17px;\n  }\n\n  .dropdown-autoclose-inside:focus-visible {\n    outline: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
